import { useEffect, useState } from "react";
import { api } from "@/App";

const ActivityHeatmap = () => {
  const [heatmapData, setHeatmapData] = useState([]);

  useEffect(() => {
    const fetchHeatmap = async () => {
      try {
        const data = await api.get("/activity/heatmap");
        setHeatmapData(data.heatmap || []);
      } catch (error) {
        console.error("Failed to fetch heatmap:", error);
        // Generate placeholder data
        const placeholder = [];
        for (let i = 0; i < 90; i++) {
          placeholder.push({ date: '', level: Math.floor(Math.random() * 5) });
        }
        setHeatmapData(placeholder);
      }
    };

    fetchHeatmap();
  }, []);

  // Organize into weeks (7 days each)
  const weeks = [];
  for (let i = 0; i < heatmapData.length; i += 7) {
    weeks.push(heatmapData.slice(i, i + 7));
  }

  return (
    <div className="overflow-hidden">
      {/* Latest week first; on narrow screens the oldest weeks are simply clipped on the right */}
      <div className="flex gap-1">
        {weeks.reverse().map((week, weekIndex) => (
          <div key={weekIndex} className="flex flex-col gap-1">
            {week.map((day, dayIndex) => (
              <div
                key={dayIndex}
                className={`w-3 h-3 rounded-sm heatmap-${day.level}`}
                title={day.date || `Day ${weekIndex * 7 + dayIndex + 1}`}
              />
            ))}
          </div>
        ))}
      </div>
      
      {/* Legend */}
      <div className="flex items-center gap-2 mt-4 text-xs text-muted-foreground">
        <span>Less</span>
        <div className="flex gap-1">
          {[0, 1, 2, 3, 4].map((level) => (
            <div key={level} className={`w-3 h-3 rounded-sm heatmap-${level}`} />
          ))}
        </div>
        <span>More</span>
      </div>
    </div>
  );
};

export default ActivityHeatmap;
